import { ProductMconTheme } from '../../../../Product/MconTheme/S/Function/product-mcon-theme.ts';
import { UtilNumberS } from '../../../../Util/Number/S/Function/module/UtilNumberS.js';
import { OMPCreatorDesignS } from './module/OMPCreatorDesignS.js';

export function getMconThemePrice(price, mcon_theme) {
  /* price : bp.mcon_base_price 또는 bp.price + bpfs 의 첫번째 가격 */
  /*
   *  크디를 위한 상품 가격 * 로열티 퍼센트
   *  10 보다 작은 경우 소수점에서 올림
   *  10 이상의 경우 10의 자리에서 올림
   * */
  const result_price =
    price * UtilNumberS.divDecimal(Number(mcon_theme._.mcon_theme_price_type.percent), 100);
  if (result_price < 10) {
    return Math.ceil(result_price);
  } else {
    return Math.ceil(result_price / 10) * 10;
  }
}

/**
 * product_mcon_theme, base_product, base_product_color를 기반으로
 * products의 mcon_theme 정보를 반환
 *
 * @param {{
 *   _: {
 *     mcon_theme: {
 *       name: string;
 *       _: {
 *         mcon_theme_price_type: {
 *           percent: number;
 *         };
 *       };
 *     };
 *   };
 * }} products_mcon_theme
 * @param {import('@/types/BaseProducts').BaseProducts} base_product
 * @param {import('@/types/ProductConstantS').BaseProductColorsAssociate} base_product_color
 * @returns {{ price: number, name: string }}
 */
export function getMconThemeDetails(products_mcon_theme, base_product, base_product_color) {
  const base_price = ProductMconTheme.getBasePriceForMcon({ base_product, base_product_color });
  const price = OMPCreatorDesignS.getMconThemePrice(base_price, products_mcon_theme._.mcon_theme);

  return {
    name: products_mcon_theme._.mcon_theme.name,
    price,
  };
}
